// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meet-team-icon-style--- {
    height: 296px;
    width: 100%;
    border-top-left-radius: 20;
    border-top-right-radius: 20;
  }
  
  .meet-team-main-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 64px;
    margin-left: 15px;
  }

  .meet-team-feature-grid-style {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* Ensures 4 items per row */
    gap: 20px; /* Adjusts spacing */
    width: 97%;
    justify-content: center;
  }
  
  .meet-team-feature-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #F8F9FA;
    border-radius: 10px;
    transition: transform 0.3s ease-in-out;
  }

  .meet-team-feature-view:hover {
    transform: translateY(-5px);
}
  
  .meet-team-feature-title-style {
    font-size: 20px;
    font-weight: 700;
    font-family: "Plus Jakarta Sans", serif;
    color: #000000;
    text-align: center;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  
  .meet-team-feature-description-style {
    font-size: 18px;
    font-weight: 700;
    font-family: "Plus Jakarta Sans", serif;
    color: #6C757D;
    max-width: 200px;
    text-align: center;
    margin-bottom: 20px;
  }
  

  .light-sub-text-style {
    font-size: 20px;
    font-weight: 400;
    font-family: "Plus Jakarta Sans", serif;
    color: #6C757D;
    text-align: center;
    margin-bottom: 40px;
  }`, "",{"version":3,"sources":["webpack://./src/pages/AboutUs/Component/MeetTeam/meetTeam.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,qCAAqC,EAAE,4BAA4B;IACnE,SAAS,EAAE,oBAAoB;IAC/B,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;AAC/B;;EAEE;IACE,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;;EAGA;IACE,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB","sourcesContent":[".meet-team-icon-style--- {\n    height: 296px;\n    width: 100%;\n    border-top-left-radius: 20;\n    border-top-right-radius: 20;\n  }\n  \n  .meet-team-main-container {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 64px;\n    margin-left: 15px;\n  }\n\n  .meet-team-feature-grid-style {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr); /* Ensures 4 items per row */\n    gap: 20px; /* Adjusts spacing */\n    width: 97%;\n    justify-content: center;\n  }\n  \n  .meet-team-feature-view {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: #F8F9FA;\n    border-radius: 10px;\n    transition: transform 0.3s ease-in-out;\n  }\n\n  .meet-team-feature-view:hover {\n    transform: translateY(-5px);\n}\n  \n  .meet-team-feature-title-style {\n    font-size: 20px;\n    font-weight: 700;\n    font-family: \"Plus Jakarta Sans\", serif;\n    color: #000000;\n    text-align: center;\n    margin-bottom: 10px;\n    margin-top: 10px;\n  }\n  \n  .meet-team-feature-description-style {\n    font-size: 18px;\n    font-weight: 700;\n    font-family: \"Plus Jakarta Sans\", serif;\n    color: #6C757D;\n    max-width: 200px;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n\n  .light-sub-text-style {\n    font-size: 20px;\n    font-weight: 400;\n    font-family: \"Plus Jakarta Sans\", serif;\n    color: #6C757D;\n    text-align: center;\n    margin-bottom: 40px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
